<template>
  <OArticleCard v-bind="$attrs" class="flex flex-col w-full sm:max-w-[332px] rounded-md border border-divider-100">
    <div class="bg-white overflow-hidden rounded-md w-full flex flex-col flex-grow">
      <OArticleCover :width="isMobile ? '100%' : 330" class="flex-shrink-0" />
      <OArticleBadge pin="left" />
      <div class="flex flex-col p-4 flex-grow">
        <div class="flex-grow">
          <OArticleTitle :level="3" class="hover:text-link-primary line-clamp-3" />
        </div>
        <div class="flex mt-1">
          <OArticleHashtag class="leading-22 mr-auto z-2" />
          <OArticleCategory class="ml-auto z-2" />
        </div>
      </div>
      <OArticleDelete v-if="isMe && isArticleList" />
    </div>
  </OArticleCard>
</template>

<script>
import { useRoute } from '@nuxtjs/composition-api';
import OArticleCard from '@/modules/card/components/ArticleCard';
import OArticleCover from '@/modules/card/components/ArticleCover';
import OArticleTitle from '@/modules/card/components/ArticleTitle';
import OArticleCategory from '@/modules/card/components/ArticleCategory';
import OArticleBadge from '@/modules/card/components/ArticleBadge';
import OArticleHashtag from '@/modules/card/components/ArticleHashtag';
import OArticleDelete from '@/modules/card/components/ArticleDelete';
import { useDevice } from '~/composables/useDevice';
import { useAuth } from '~/modules/auth/state/useAuth';

export default {
  components: {
    OArticleCard,
    OArticleCover,
    OArticleTitle,
    OArticleCategory,
    OArticleBadge,
    OArticleHashtag,
    OArticleDelete,
  },
  inheritAttrs: false,
  setup({ article }) {
    const { isMobile } = useDevice();
    const { user } = useAuth();
    const route = useRoute();
    const username = route.value.params.username;
    const slug = route.value.path.split('/')[3];
    const isMe = user.value && username === user.value.username;
    const isArticleList = slug === 'icerikler' || slug === '';

    return {
      isMobile,
      isMe,
      isArticleList,
    };
  },
};
</script>
